export default __webpack_public_path__ + "static/media/bscHoverMobile.1da78b6b.svg";